import { Tooltip, IconButton, TooltipProps } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import React from 'react'

interface HelpIconProps {
  helperText: string
  placement: TooltipProps['placement']
}

export const HelpIcon: React.FC<HelpIconProps> = ({
  helperText,
  placement
}) => {
  return (
    <Tooltip title={helperText} placement={placement}>
      <IconButton>
        <HelpOutline />
      </IconButton>
    </Tooltip>
  )
}
